@use "foundation/_colors";

.permissions {
  h3 {
    margin-top: 0;
  }
  .active {
    color: colors.$error-color;
  }
  div.cta {
    display: flex;
    align-items: center;
    svg {
      color: colors.$senary-brand-color;
      height: 25px;
      width: 20px;
      margin-right: 7px;
    }
    p {
      font-size: 0.88em;
    }
    a {
      color: colors.$senary-brand-color;
      text-decoration: underline;
    }
  }
  .permission-list {
    ul {
      margin-top: 15px;
    }
    li {
      display: flex;
      align-items: center;
      margin: 10px 0px;
    }
    img {
      margin-right: 10px;
    }
  }
}

